var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShareArrowV2 = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 42.38 36.73",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.52,17V7.39a1.49,1.49,0,0,1,.84-1.52,1.47,1.47,0,0,1,1.72.4q9,8.33,18,16.62a1.45,1.45,0,0,1,0,2.41L26.05,42a1.44,1.44,0,0,1-2.53-1.09c0-3,0-6.09,0-9.14v-.47c-.58,0-1.13,0-1.68,0a33,33,0,0,0-6.62,1A13.91,13.91,0,0,0,6,39.85c-.32.63-.63,1.26-1,1.88a1.41,1.41,0,0,1-1.53.71,1.39,1.39,0,0,1-1.11-1.33,47.52,47.52,0,0,1,1-11.22,15.13,15.13,0,0,1,4.75-8.27,17.45,17.45,0,0,1,7.14-3.51,37.24,37.24,0,0,1,7.86-1Zm2.83,20.8L41.22,24.1,26.35,10.37v8a1.42,1.42,0,0,1-1.54,1.54c-1,0-2,0-3,.1a27,27,0,0,0-7.9,1.5,11.58,11.58,0,0,0-6.81,6.08A19,19,0,0,0,5.52,33.4c-.08.66-.14,1.32-.21,2.1a1.76,1.76,0,0,0,.21-.24,16.3,16.3,0,0,1,8.94-5.71,39,39,0,0,1,10.26-1.21A1.44,1.44,0,0,1,26.35,30v7.87Z",
    transform: "translate(-2.34 -5.74)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShareArrowV2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share_arrow_v2.00e467be.svg";
export { ForwardRef as ReactComponent };